import React, { useState } from "react";

function FeaturedRestCards(props) {
  const [like, setLike] = useState(props.liked);

  return (
    <div className="">
      <a
        href="/"
        className="m-1 flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow md:flex-row md:h-44 lg:h-56 md:max-w-xl lg:max-w-xl hover:bg-gray-100 dark:border-gray-700 bg-white-800"
      >
        <img
          className="w-full h-full object-fit rounded-t-lg md:w-48 md:rounded-none md:rounded-l-lg"
          src={props.restImg}
          alt=""
        />
        <div className="flex flex-col justify-between p-4 leading-normal">
          <h5 className="mb-1 text-2xl font-bold tracking-tight text-black-900 text-justify">
            {props.restName}
          </h5>
          <p className="mb-1 font-normal text-gray-700 dark:text-gray-400 text-justify">
            {props.restDish}
          </p>

          {/* Rating Stars */}
          <div className="flex items-center mt-1 mb-1">
            {[...Array(props.rating)].map((x, i) => {
              return (
                <svg
                  aria-hidden="true"
                  className="w-5 h-5 text-yellow-300"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>First star</title>
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
              );
            })}

            <span className="bg-blue-100 ml-2 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800">
              {props.rating}
            </span>
          </div>

          {/* Like Button */}
          <div className="text-justify">
            <button
              className="border-none"
              onClick={(e) => {
                e.preventDefault();
                setLike((like) => !like);
              }}
            >
              <svg
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
              >
                {like ? (
                  <path d="M12 21.593c-5.63-5.539-11-10.297-11-14.402 0-3.791 3.068-5.191 5.281-5.191 1.312 0 4.151.501 5.719 4.457 1.59-3.968 4.464-4.447 5.726-4.447 2.54 0 5.274 1.621 5.274 5.181 0 4.069-5.136 8.625-11 14.402m5.726-20.583c-2.203 0-4.446 1.042-5.726 3.238-1.285-2.206-3.522-3.248-5.719-3.248-3.183 0-6.281 2.187-6.281 6.191 0 4.661 5.571 9.429 12 15.809 6.43-6.38 12-11.148 12-15.809 0-4.011-3.095-6.181-6.274-6.181" />
                ) : (
                  <path d="M12 4.435c-1.989-5.399-12-4.597-12 3.568 0 4.068 3.06 9.481 12 14.997 8.94-5.516 12-10.929 12-14.997 0-8.118-10-8.999-12-3.568z" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </a>
    </div>
  );
}

export default FeaturedRestCards;
